import { FormManagementProps } from '@/type/form.types';
import { FieldValues, Path } from 'react-hook-form';

export const setBranchRequiredFields = <TSchema extends FieldValues>({
  setValue,
  data,
}: FormManagementProps<TSchema>) => {
  setValue('name' as Path<TSchema>, data.name ?? '');
  setValue('addressLine1' as Path<TSchema>, data.addressLine1 ?? '');
  setValue('postalCode' as Path<TSchema>, data.postalCode ?? '');
  setValue('city' as Path<TSchema>, data.city ?? '');
  setValue('primaryPhone' as Path<TSchema>, data.primaryPhone ?? '');
  setValue('secondaryPhone' as Path<TSchema>, data.secondaryPhone ?? '');
  setValue('email' as Path<TSchema>, data.email ?? '');
};
